<template>
  <div :class="['line-block-container', `${size}-icon` ]">
    <img :src="getUrlIcons(icon)" alt="lin">
  </div>
</template>

<script>
export default {
  name: "LineBlock",
  props: {
    icon: {
      type: String,
      default: 'line'
    },
    size: {
      type: String,
      default: 'default'
    }
  }
}
</script>

<style scoped lang="scss">
  .line-block-container {
    width: 0;
    display: flex;
    & img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }


  @media (max-width: 3024px){

    .line-block-container {
      &.big-icon {
        min-width: 50px;
        height: 11px;
      }
      &.default-icon {
        min-width: 26px;
        height: 16px;
      }
    }
  }


  @media (max-width: 1920px) {
    .line-block-container {
      &.big-icon {
        min-width: 46px;
        height: 11px;
      }
      &.default-icon {
        min-width: 17px;
        height: 4px;
      }
    }
  }


  @media (max-width: 1600px) {
    .line-block-container {
      &.big-icon {
        min-width: 37px;
        height: 9px;
      }
      &.default-icon {
        min-width: 17px;
        height: 4px;
      }
    }
  }
  @media (max-height: 800px) {
    .line-block-container {
      &.big-icon {
        min-width: 32px;
        height: 8px;
      }
      &.default-icon {
        min-width: 14px;
        height: 3px;
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {

    .line-block-container {
      &.big-icon {
        min-width: 37px;
        height: 9px;
      }
      &.default-icon {
        min-width: 17px;
        height: 4px;
      }
    }
  }

  @media (max-width: 1133px) {
    .line-block-container {
      &.big-icon {
        min-width: 32px;
        height: 8px;
      }
      &.default-icon {
        min-width: 14px;
        height: 3px;
      }
    }

  }

  @media (max-width: 769px) {
    .line-block-container {
      &.big-icon {
        min-width: 30px;
        height: 6px;
      }
      &.default-icon {
        min-width: 14px;
        height: 3px;
      }
    }
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    .line-block-container {
      &.big-icon {
        min-width: 33px;
        height: 8px;
      }
    }
  }

  @media (min-height: 600px) and (max-height: 630px){

    //8 plus
  }

  @media (max-width: 375px) {
    .line-block-container {
      &.big-icon {
        min-width: 24px;
        height: 5px;
      }
      &.default-icon {
        min-width: 14px;
        height: 3px;
      }
    }
  }

  @media (max-width: 375px) and (min-height: 630px) {
    //x
  }


  @media (max-width: 320px) {
    //se old
  }

  @media (min-width: 3025px) {

    .line-block-container {
      &.big-icon {
        min-width: 81px;
        height: 19px;
      }
      &.default-icon {
        min-width: 53px;
        height: 13px;
      }
    }
  }

</style>